import React from 'react';

// Styles
import './WpDetailList.scss';

type Props = {
  children: React.ReactNode;
};

const WpDetailList = ({ children }: Props) => {
  const baseClassName = 'WpDetailList';
  return (
    <div className={baseClassName}>
      {React.Children.map(children, (child: React.ReactElement<any>) => {
        if (child) return React.cloneElement(child);
        return null;
      })}
    </div>
  );
};

export default WpDetailList;
